/* eslint-disable import/prefer-default-export */

/*
 * @Author: wangshengqiang
 * @Date: 2021-06-10 15:16:34
 * @LastEditTime: 2022-01-09 15:44:21
 * @LastEditors: wangshengqiang
 * @Description: 常用验证格式的方法
 */
// 验证是否是正确身份证号码
export const isCard = idNum => {
  const arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; // 加权因子

  const arrValid = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]; // 校验码

  if (/^\d{17}\d|x$/i.test(idNum)) {
    let sum = 0; // 对前17位数字与权值乘积求和

    for (let i = 0; i < idNum.length - 1; i++) {
      sum += parseInt(idNum.substr(i, 1), 10) * arrExp[i];
    } // 计算模（固定算法）


    const idx = sum % 11; // 检验第18为是否与校验码相等

    return arrValid[idx] == idNum.substr(17, 1).toUpperCase();
  }

  return false;
}; // 验证是否是正确身份证号码

export const idCard1 = value => {
  if (/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(value)) {
    // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
    // 下面分别分析出生日期和校验位
    const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    value = value.replace(/^\s+|\s+$/g, ''); // 去掉两边空格

    if (value.length === 15) {
      const arrSplit = value.match(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/); // 检查生日日期是否正确

      const dtmBirth = new Date(`19${arrSplit[2]}/${arrSplit[3]}/${arrSplit[4]}`);

      if (String(dtmBirth) !== 'Invalid Date') {
        // 将15位身份证转成18位
        // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        let nTemp = 0;
        let i;
        value = `${value.substr(0, 6)}19${value.substr(6, value.length - 6)}`;

        for (i = 0; i < 17; i++) {
          nTemp += value.substr(i, 1) * arrInt[i];
        }

        value += arrCh[nTemp % 11];
      }
    }

    if (value.length === 18) {
      const arrSplit = value.match(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/); // 检查生日日期是否正确

      const dtmBirth = new Date(`${arrSplit[2]}/${arrSplit[3]}/${arrSplit[4]}`);

      if (String(dtmBirth) !== 'Invalid Date') {
        // 检验18位身份证的校验码是否正确。
        // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        let nTemp = 0;
        let i;

        for (i = 0; i < 17; i++) {
          nTemp += value.substr(i, 1) * arrInt[i];
        }

        const valnum = arrCh[nTemp % 11];

        if (valnum === value.substr(17, 1)) {
          return true;
        }
      }
    }
  }

  return false;
}; // 验证手机号

export const isPhone = phone => {
  const reg = /^1[3|6|4|5|7|8|9]\d{9}$/;
  return reg.test(phone);
}; // 邮编验证6位数字

export const isPostcode = val => {
  return /^[0-9]{6}$/g.test(val);
}; // 检查邮箱是否正确

export const isEmail = email => {
  const reg = new RegExp(/^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/);
  return reg.test(email);
}; // 判断是否为中文

export const isCH = text => /^[\u4e00-\u9fa5]+$/.test(text); // 检查姓名是否正确

export const isName = name => /^(?:[\u4e00-\u9fa5]+)(?:●[\u4e00-\u9fa5]+)*$|^[a-zA-Z0-9]+\s?[\.·\-()a-zA-Z]*[a-zA-Z]+$/.test(name); // 检查是否为数据 ==》12 12.2 都是正确的

export const isNumber = value => /^[0-9]+([.][0-9]{1,2})?$/.test(value); // 验证是否为出生证

export const RegMap = {
  isPassportCard: val => val.length >= 5 && /^[^\u4e00-\u9fa5]+$/.test(val),
  // 护照
  isHMPassCard: val => /^[CW]\d{8}$/.test(val),
  // 港澳通行证
  isOfficerCard: val => /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/.test(val),
  // 军官证
  isHomeReturnCard: val => /^[mMhH]\d{10}|[mMhH]\d{8}$/.test(val),
  // 回乡证
  isBirthCard: val => /^[a-zA-Z]\d{9}$/.test(val),
  // 出生证
  isSUCC: val => /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/.test(val) // 社会统一信用代码

}; // 证件类型长度集合

export const certNoLengthMap = {
  I: 18,
  // 身份证
  SUCC: 18 // 社会统一信用代码

}; // 证件规则验证

export const certNoTestMap = {
  I: isCard,
  // 身份证
  M: RegMap.isOfficerCard,
  // 军官证
  B: RegMap.isBirthCard,
  // 出生证
  P: RegMap.isPassportCard,
  // 护照
  GA: RegMap.isHMPassCard,
  // 港澳通行证
  GJ: RegMap.isHomeReturnCard,
  // 回乡证
  SUCC: RegMap.isSUCC // 社会统一信用代码

};